module.exports = __webpack_public_path__ + "img/dollar-selected.d8692e9b.svg";